exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".job-no{color:#007bff;text-decoration:none;font-weight:700;position:relative;transition:color .3s,transform .3s}.job-no:hover{color:#0056b3;transform:scale(1.1)}.job-no:after{content:\"\";display:block;width:0;height:2px;background:#007bff;transition:width .3s;position:absolute;bottom:0;left:0}.job-no:hover:after{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9c9e2482","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/airFreight/viewAirCCTPT.vue
// module id = 1762
// module chunks = 0